/**
 * Decide whether the auto-select hook may commit a date for a single leg.
 *
 * Pure function over a small bag of normalized inputs. The hook computes
 * `manualSelectionInProgress` and passes it in so this helper stays oblivious
 * to calendar state and leg-specific details.
 *
 * @param {Object} params
 * @param {string|null} params.pickedDateKey YYYY-MM-DD that `pickRoundTripDates` chose, or null.
 * @param {boolean} params.hasConcreteDate True when the external prop already has a concrete date.
 * @param {string|null} params.lastAutoSelectedKey YYYY-MM-DD the hook last committed for this leg.
 * @param {boolean} params.manualSelectionInProgress True if the user is mid-pick.
 * @returns {boolean} True when the caller should fire the commit callback.
 */
const shouldAutoSelectLeg = ({
  pickedDateKey,
  hasConcreteDate,
  lastAutoSelectedKey,
  manualSelectionInProgress,
}) => {
  if (!pickedDateKey) return false;
  if (hasConcreteDate) return false;
  if (manualSelectionInProgress) return false;
  if (pickedDateKey === lastAutoSelectedKey) return false;
  return true;
};

export default shouldAutoSelectLeg;
